import React, { ElementType, ReactNode } from 'react';
import { IconTextRowRoot, IconTextRowText } from './IconTextRow.styles';

export type IconTextRowProps = {
  icon: ElementType;
  children: ReactNode;
  /** Top-aligns the icon with the first line and lets long text wrap. */
  multiline?: boolean;
};

export const IconTextRow = ({ icon: Icon, children, multiline }: IconTextRowProps) => (
  <IconTextRowRoot
    direction="row"
    alignItems={multiline ? 'flex-start' : 'center'}
    spacing={0.5}
    multiline={multiline}
  >
    <Icon color="action" />
    <IconTextRowText variant="body2" color="text.secondary" multiline={multiline}>
      {children}
    </IconTextRowText>
  </IconTextRowRoot>
);
